module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedItem d-flex flex-row justify-content-between"
  }, [_c('div', {
    staticClass: "panel w-100 singleCard lightest d-flex flex-column",
    class: {
      'bg-color-6': _vm.unreadNotificationsNr > 0, 'bg-dark': _vm.unreadNotificationsNr == 0
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row h-50"
  }, [_c('div', {
    staticClass: "w-50 fs-uberhuge font-weight-600"
  }, [_vm._v(_vm._s(_vm.unreadNotificationsNr))]), _vm._v(" "), _c('div', {
    staticClass: "w-50 d-flex align-items-center justify-content-end mt-3"
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.cardInfo.nrPickups > 0) ? _c('div', {
    staticClass: "panel w-100 singleCard bg-dark lightest"
  }, [_c('div', {
    staticClass: "text-uppercase fs-larger h-50"
  }, [_vm._v("Pickups")]), _vm._v(" "), _c('div', {
    staticClass: "h-50 d-flex flex-column justify-content-end"
  }, [_c('div', {
    staticClass: "font-weight-600"
  }, [_vm._v(_vm._s(_vm.cardInfo.nrPickups) + " active"), _c('br'), _vm._v(" pickups now")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel w-100 singleCard bg-dark lightest"
  }, [_c('div', {
    staticClass: "text-uppercase fs-large h-50"
  }, [_vm._v("Bookings")]), _vm._v(" "), _c('div', {
    staticClass: "h-50 d-flex flex-column justify-content-end"
  }, [_c('div', {
    staticClass: "font-weight-600"
  }, [_vm._v(_vm._s(_vm.cardInfo.nrBookings) + " new bookings")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-50 d-flex flex-column justify-content-end"
  }, [_c('div', {
    staticClass: "font-weight-600"
  }, [_vm._v("Alerts to read")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-65352dc7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65352dc7"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/FeedcardMulti.vue
// module id = 1494
// module chunks = 0